// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ChevronLeftOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 320 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M9.4 233.4a32.05 32.05 0 000 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"}}]},"name":"chevron-left","theme":"outlined"};

const ChevronLeftOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ChevronLeftOutlinedSvg} />;
  ChevronLeftOutlined.displayName = 'ChevronLeftOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ChevronLeftOutlined);
